module.exports = __webpack_public_path__ + "img/hcl-hero.6c1dccb2.png";